<script>
  import { onMount } from "svelte";
  import { SvelteToast } from "@zerodevx/svelte-toast";

  import axios from "axios";
  import router from "page";

  import NavBar from "./components/Navigation/Navigation.svelte";
  import Footer from "./components/Navigation/Footer.svelte";

  import Home from "./routes/Home.svelte";
  import Changelog from "./routes/Changelog.svelte";
  import Privacy from "./routes/Privacy.svelte";
  import Signin from "./routes/Signin.svelte";
  import Login from "./routes/Auth/Login.svelte";
  import Logout from "./routes/Auth/Logout.svelte";

  import Account from "./routes/Platform/Account.svelte";

  import MissingPage from "./routes/404.svelte";

  axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
  axios.defaults.xsrfCookieName = "csrf_access_token";

  let page;
  let params = null;
  let user = null;
  let staging;

  if (APIBACKEND === "https://stagingapi.cofounder.chat") {
    staging = true;
  } else {
    staging = false;
  }

  onMount(async () => {
    axios
      .get(APIBACKEND + "/user", { withCredentials: true })
      .then((res) => {
        user = res.data;
      })
      .catch(() => {});

    router("/", () => (page = Home));
    router("/changelog", () => (page = Changelog));
    router("/privacy", () => (page = Privacy));
    router("/signin", () => (page = Signin));
    router("/logout", () => (page = Logout));
    router(
      "/login/:magic_link",

      // Before we set the component
      (ctx, next) => {
        params = ctx.params;
        next();
      },

      // Finally set the component
      () => (page = Login)
    );

    // Private Routes
    router("/account", () =>
      user ? (page = Account) : window.location.replace("/signin")
    );
    router("/*", () => (page = MissingPage));

    router.start();
  });
</script>

<style lang="scss">
  @import "./styles/_mixins.scss";

  .staging-banner {
    position: fixed;
    width: 100%;
    background-color: yellow;
    margin: 0;
    text-align: center;
    padding-top: 6px;
    padding-bottom: 6px;
    left: 0;
    z-index: 1;
  }

  :global(.chaport-container) {
    display: none;

    @include sm {
      display: block;
    }
  }
</style>

{#if staging}
  <div class="staging-banner">
    <p>STAGING</p>
  </div>
{/if}

<NavBar {user} />
<SvelteToast options={{ reversed: true, intro: { y: -192 } }} />

<main class="content">
  <svelte:component this={page} {params} {user} />
</main>

<Footer />
